import {
    Card, CardContent, CardHeader, Grid, CardMedia,
    TextField, Button, Collapse, Alert, Box, IconButton
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

export default function RestablecerPassword() {
    const [usuario, setUsuario] = useState({
        id: '',
        emailInstitucional: ''
    })

    const [loading, setLoading] = useState(false)
    const [open, setOpen] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [severity, setSeverity] = useState('error')

    const navigate = useNavigate()

    const handleSubmit = async (e) => {
        e.preventDefault()
        const servidor = window.location.host
        setLoading(true)
        //console.log(`usuario: ${JSON.stringify(usuario)}`)
        if(isNaN(usuario.id)){
            setMensaje('Verifica que tus datos sean correctos, eso no parece ser una matrícula o número económico')
            setOpen(true)
            return
        }
        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/auth/restablecerPassword`, {
            method: "POST",
            body: JSON.stringify(usuario),
            headers: { "Content-Type": "application/json", "servidor": servidor },
        })
        const data = await res.json()

        if(res.status===200||res.status===204)
            setSeverity('success')
        else
            setSeverity('error')

        if (data.message) {
            setOpen(true)
            setMensaje(`${data.message}`)
            setLoading(false)
            sessionStorage.clear()//setItem('token', null)
            return
        }
        else {
            setOpen(true)
            setMensaje('Se ha enviado un mensaje a la dirección de correo que proporcionaste')
        }

        setLoading(false)

        navigate('/')
    }

    const handleChange = e => {
        setUsuario({ ...usuario, [e.target.name]: e.target.value })
    }
    return (
        <Grid container direction='row' justifyContent='center' style={{ marginTop: 50 }}>
            <Grid item xs={12} sm={7}>
                <Card>
                    <CardMedia
                        component="img"
                        image="/images/nadu.png"
                        alt="Nadu"
                        style={{ objectFit: 'contain' }}
                    />
                </Card>
            </Grid>

            <Grid item xs={12} sm={5}>
                <Card>
                    <CardHeader title='Restablecimiento de Password'></CardHeader>
                    <CardContent>
                        <form onSubmit={handleSubmit}>
                            <Grid container justifyContent='stretch' spacing={5} style={{ marginTop: 5 }}>
                                <Grid item xs={12} sm={12}>
                                    <TextField label='Escriba su número económico o matrícula' name='id' onChange={handleChange} value={usuario.id} sx={{ width: '100%' }} />
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <TextField label='Escriba su correo institucional' name='emailInstitucional' type="email" onChange={handleChange} value={usuario.emailInstitucional} sx={{ width: '100%' }} />
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <Button variant='contained' color='primary' type='submit' style={{ marginTop: 43 }} disabled={!usuario.id || !usuario.emailInstitucional || loading}>
                                        Enviar
                                    </Button>
                                </Grid>
                            </Grid>

                        </form>
                        <Box sx={{ width: '100%' }}>
                            <Collapse in={open}>
                                <Alert severity={severity}
                                    action={
                                        <IconButton
                                            aria-label="close"
                                            color="inherit"
                                            size="small"
                                            onClick={() => {
                                                setOpen(false);
                                            }}
                                        >
                                            <CloseIcon fontSize="inherit" />
                                        </IconButton>
                                    }
                                    style={{ marginTop: 30 }}
                                >
                                    {mensaje}
                                </Alert>
                            </Collapse>
                        </Box>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>

    )
}